$(document).ready(function(){
  const customerDefaultCountryCode = $('#header-container').data('country-code');
  const ipInfo = JSON.parse(window.localStorage.getItem('ip_info'));
  const ipCountryCode = ipInfo.country;
  console.log("Users Country" + ipCountryCode)
  const euDistributionCountries = theme.settings.euDistributionCountries;
  console.log(euDistributionCountries)
  const restockedLinkEl = $('ul .nav__sublist li a[href="/collections/restocked"]');
  if (customerDefaultCountryCode) {
    if (euDistributionCountries.includes(customerDefaultCountryCode)) {
      restockedLinkEl.attr('href', '/collections/restocked-uk');
    } else {
      restockedLinkEl.attr('href', '/collections/restocked-markham');
    }
  } else if (ipCountryCode) {
    if (euDistributionCountries.includes(ipCountryCode)) {
      restockedLinkEl.attr('href', '/collections/restocked-uk');
    } else {
      restockedLinkEl.attr('href', '/collections/restocked-markham');
    }
  }
});